<app-filter-container>
    <form [formGroup]="filterForm">
        <app-form-section>
            <app-form-row>
                <h1>{{ 'MENU.AGREEMENT' | translate }}</h1>
                <app-form-group class="actionbuttons">
                    <button [disabled]="!hasIncludeFlags()" (click)="changeResponsible()" type="button">
                        {{ 'BUTTONS.CHANGE_AGREEMENT_RESPONSIBLE' | translate }}
                    </button>
                    <button [disabled]="!hasIncludeFlags()" (click)="confirmRemoveAgreements($event)" type="button">
                        {{ 'BUTTONS.REMOVE' | translate }}
                        <span class="material-symbols-rounded trailing" aria-hidden="true"> delete </span>
                    </button>
                    <button
                        [disabled]="!hasIncludeFlags()"
                        (click)="renegotiateAgreements()"
                        type="button"
                        class="renegotiate"
                        [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.RENEGOTIATE' | translate"
                        [tooltipPosition]="'left'"
                    >
                        {{ 'BUTTONS.RENEGOTIATE' | translate }}
                    </button>
                    <button
                        *appHasPermissions="[permissions.WriteAgreement]"
                        (click)="goToCreateNewAgreement()"
                        class="primary"
                        type="button"
                    >
                        {{ 'BUTTONS.CREATE_AGREEMENT' | translate }}
                        <span class="material-symbols-rounded trailing" aria-hidden="true"> add_2 </span>
                    </button>
                </app-form-group>
            </app-form-row>

            <div class="action-box">
                <div class="search-box">
                    <app-search-input formControlName="searchPhrase" />

                    <div class="actions">
                        <ng-container *ngIf="numOfAgreements">
                            <div class="agreement-summary">
                                <span
                                    [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.NUM_OF_AGREEMENTS' | translate"
                                    class="material-symbols-rounded leading"
                                    aria-hidden="true"
                                >
                                    contract
                                </span>
                                <span>{{ numOfAgreements }}</span>
                                <span
                                    [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.TOTAL_VALUE' | translate"
                                    class="material-symbols-rounded leading"
                                    aria-hidden="true"
                                >
                                    payments
                                </span>
                                <span [appFormatCurrency]="totalValue"></span>
                            </div>
                        </ng-container>
                        <button
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.SHOW_HIDE' | translate"
                            (click)="showHeader = !showHeader"
                            class="text"
                            type="button"
                        >
                            <span class="material-symbols-rounded leading" aria-hidden="true" *ngIf="showHeader">
                                visibility
                            </span>
                            <span class="material-symbols-rounded leading" aria-hidden="true" *ngIf="!showHeader">
                                visibility_off
                            </span>
                            <span>
                                {{ 'BUTTONS.HEADERS' | translate }}
                            </span>
                        </button>
                        <button
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.SHOW_HIDE' | translate"
                            [tooltipPosition]="'left'"
                            (click)="showFilter = !showFilter"
                            [ngClass]="{ activated: !showFilter }"
                            class="text"
                            type="button"
                        >
                            <span class="material-symbols-rounded leading" aria-hidden="true"> filter_list </span>
                            <span>{{ 'BUTTONS.FILTER_TOGGLE_BUTTON' | translate }}</span>
                        </button>

                        <button *ngIf="!isFilterEmpty" (click)="clearFilter()" class="text" type="button">
                            <span>{{ 'BUTTONS.FILTER_CLEAR_FILTER' | translate }}</span>
                            <span class="material-symbols-rounded trailing" aria-hidden="true"> clear </span>
                        </button>
                    </div>
                </div>
                <div class="filter-box">
                    <app-form-group>
                        <app-agreement-filter
                            [tableType]="tableType"
                            [config]="filterConfig"
                            [visible]="showFilter"
                            (filterChange)="onFilterChange($event)"
                            (isFilterEmptyChanged)="isFilterEmpty = $event"
                        ></app-agreement-filter>
                    </app-form-group>
                </div>
            </div>
        </app-form-section>
    </form>
</app-filter-container>
<div>
    <app-table [loading]="loading" [clickable]="true">
        <tr thead [hidden]="!showHeader" class="distinct">
            <app-table-header
                [align]="align.Center"
                [width]="1"
                *appHasPermissions="[permissions.WriteAgreement]"
                [checkbox]="true"
                (checkedChanged)="onCheckedAllChange($event)"
            />
            <app-table-header
                [isActive]="sortKey === 'name'"
                [defaultAscending]="sortKey === 'name' && sortAscending"
                [sort]="true"
                [width]="20"
                [text]="'FEATURES.AGREEMENTS.COLUMNS.NAME' | translate"
                [secondaryText]="
                    ('FEATURES.AGREEMENTS.COLUMNS.AGREEMENTNO' | translate) +
                    ' ' +
                    ('FEATURES.AGREEMENTS.COLUMNS.AGREEMENTTYPENAME' | translate)
                "
                (sortChanged)="onSortChange('name', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'customerName'"
                [defaultAscending]="sortKey === 'customerName' && sortAscending"
                [sort]="true"
                [width]="20"
                [text]="'FEATURES.AGREEMENTS.COLUMNS.CUSTOMER' | translate"
                [secondaryText]="'COLUMNS.RESPONSIBLE' | translate"
                (sortChanged)="onSortChange('customerName', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'counterpartName'"
                [defaultAscending]="sortKey === 'counterpartName' && sortAscending"
                [sort]="true"
                [width]="20"
                [text]="'FEATURES.AGREEMENTS.COLUMNS.COUNTERPART' | translate"
                [secondaryText]="'COLUMNS.RESPONSIBLE' | translate"
                (sortChanged)="onSortChange('counterpartName', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'area'"
                [defaultAscending]="sortKey === 'area' && sortAscending"
                [sort]="true"
                [width]="14"
                [text]="'FEATURES.AGREEMENTS.COLUMNS.AREA' | translate"
                [secondaryText]="'FEATURES.AGREEMENTS.COLUMNS.CATEGORY' | translate"
                (sortChanged)="onSortChange('area', $event)"
            />
            <app-table-header
                [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.VALUE' | translate"
                [isActive]="sortKey === 'value'"
                [defaultAscending]="sortKey === 'value' && sortAscending"
                [sort]="true"
                [width]="10"
                [text]="'FEATURES.AGREEMENTS.COLUMNS.VALUE' | translate"
                (sortChanged)="onSortChange('value', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'lastDayOfNotice'"
                [defaultAscending]="sortKey === 'lastDayOfNotice' && sortAscending"
                [sort]="true"
                [align]="align.Right"
                [width]="16"
                [text]="'FEATURES.AGREEMENTS.COLUMNS.LAST_DAY_OF_NOTICE' | translate"
                [secondaryText]="'FEATURES.AGREEMENTS.COLUMNS.VALID_FROM_TO' | translate"
                (sortChanged)="onSortChange('lastDayOfNotice', $event)"
            />
        </tr>
        <ng-container tbody>
            <tr *ngFor="let item of agreements$ | async" [appTooltip]="getTitle(item)" [tooltipPosition]="'pointer'">
                <td class="action" *appHasPermissions="[permissions.WriteAgreement]">
                    <app-checkbox
                        *ngIf="hasWritePermission(item)"
                        [ngModel]="includeFlags[item.id] || false"
                        (ngModelChange)="onIncludeToggle(item.id, $event)"
                    />
                </td>
                <td (click)="navigateToAgreement(item.id)">
                    {{ item.name }}<br />
                    <span class="secondary">{{ item.agreementNo }}, {{ item.agreementTypeName }}</span>
                </td>
                <td (click)="navigateToAgreement(item.id)">
                    {{ item.customerName }}<br />
                    <span class="secondary">{{ item.responsible }}</span>
                </td>
                <td (click)="navigateToAgreement(item.id)">
                    {{ item.counterpartName }}<br />
                    <span class="secondary">{{ item.counterpartResponsible }}</span>
                </td>
                <td (click)="navigateToAgreement(item.id)">
                    {{ item.area }}<br />
                    <span class="secondary"> {{ item.category }}</span>
                </td>
                <td (click)="navigateToAgreement(item.id)">
                    <span [appFormatCurrency]="item.value"></span>
                </td>

                <td (click)="navigateToAgreement(item.id)" class="date">
                    <span class="right {{ getRowClass(item) }}">
                        {{ getDateForStatus(item) }}
                    </span>
                    <br />
                    <span class="secondary">
                        {{ item.validFrom | dateTime: 'yyyy-MM-dd' | replaceEmptyString }} -
                        {{ item.validTo | dateTime: 'yyyy-MM-dd' | replaceEmptyString }}
                    </span>
                </td>
            </tr>
        </ng-container>
    </app-table>
</div>
